module.exports = __webpack_public_path__ + "static/media/refreshments-brikk-preview.0961ca91.png";